import Const from 'const';

class RangeOfOutcomes {
    private readonly valuesMap = Const.RANGES_OF_OUTCOMES_DEFAULT_VALUES;
    constructor(private readonly currentValue?: number) {}
    getRangeOfOutcomes(sport?: string): number {
        if (this.currentValue !== undefined) {
            return this.currentValue;
        }

        return sport !== undefined && sport in this.valuesMap
            ? this.valuesMap[sport]
            : Const.RANGES_OF_OUTCOMES_COMMON_DEFAULT_VALUE;
    }
    isDefaultValue(): boolean {
        return this.getRangeOfOutcomes() === Const.RANGES_OF_OUTCOMES_COMMON_DEFAULT_VALUE;
    }
}

const rangeOfOutcomes = new RangeOfOutcomes();

export default function (state = rangeOfOutcomes, action) {
    switch (action.type) {
        case Const.SET_RANGE_OF_OUTCOMES:
            return new RangeOfOutcomes(Number(action.value));

        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new RangeOfOutcomes();

        default:
            return state;
    }
}
